import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const CustomPageDrawerMenu = (props) => {

  let {
    headerBlock,
    onClose,
    show,
    fallbackBrandLogo
  } = props;

  let _clickNav = (e) => {
    e.preventDefault();
    onClose();
  };

  const onCloseClick = (e) => {
    if (onClose) {
      onClose();
    }
  };

  const renderSidebarMenuList = (headerMenus, index = []) => {
    if (!Array.isArray(headerMenus)) return undefined;
    return headerMenus.map((menu, index) => {
      return (
        <li key={index} className={clsx("drawer-menu-item", index==0?'active':'')}>
          <a className="fs-16 nav-link js_scroll" href={menu.menuUrl} onClick={_clickNav}>
            <i className="fa fa-chevron-right" ></i> { menu.menuText }
          </a>
        </li>
      );
    });
  };

  return (
    <React.Fragment>
      <div className={clsx('drawer-overlay', { 'show': show })} ></div>
      <div className={clsx('drawer-wrapper', { 'slide-out': show })} >
        <div>
          <div className="text-white" id="drawer-float-close" onClick={onCloseClick}><i className="fa fa-times d-block"></i>閉じる</div>
        </div>
        <div className="drawer-nav" id="drawer-sidebar" role="navigation">
          <div className="d-flex flex-column h-100 drawer-content">
            <ul className="drawer-menu">
              <li className="drawer-brand">
                <a href="#page-wrapper" className="js_scroll" onClick={_clickNav}>
                  <img className="img-fluid" src={headerBlock.headerLogoUrl} onError={fallbackBrandLogo} />
                </a>
              </li>
              { renderSidebarMenuList(headerBlock.headerMenus) }
            </ul>
            <div className="doterai-block flex-grow-1"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

CustomPageDrawerMenu.propTypes = {
  headerBlock: PropTypes.shape({
    headerType: PropTypes.string,
    headerLayoutType: PropTypes.string,
    headerLogoUrl: PropTypes.string,
    headerMenus: PropTypes.arrayOf(PropTypes.shape( {
      menuType: PropTypes.string,
      menuText: PropTypes.string,
      menuUrl: PropTypes.string,
      pageId: PropTypes.number,
      pageBlockId: PropTypes.number,
    })),
  }).isRequired,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  fallbackBrandLogo: PropTypes.func
};

export default CustomPageDrawerMenu;
